/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventStateResponseDto } from './EventStateResponseDto';
import {
    EventStateResponseDtoFromJSON,
    EventStateResponseDtoFromJSONTyped,
    EventStateResponseDtoToJSON,
    EventStateResponseDtoToJSONTyped,
} from './EventStateResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListEventStatesResponseDto
 */
export interface ListEventStatesResponseDto {
    /**
     * 
     * @type {Array<EventStateResponseDto>}
     * @memberof ListEventStatesResponseDto
     */
    data: Array<EventStateResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListEventStatesResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListEventStatesResponseDto interface.
 */
export function instanceOfListEventStatesResponseDto(value: object): value is ListEventStatesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListEventStatesResponseDtoFromJSON(json: any): ListEventStatesResponseDto {
    return ListEventStatesResponseDtoFromJSONTyped(json, false);
}

export function ListEventStatesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEventStatesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EventStateResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListEventStatesResponseDtoToJSON(json: any): ListEventStatesResponseDto {
    return ListEventStatesResponseDtoToJSONTyped(json, false);
}

export function ListEventStatesResponseDtoToJSONTyped(value?: ListEventStatesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(EventStateResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

